<div class="mtc-appbar-container">
  <div class="mtc-appbar">
    @if (isLoggedIn && state.navItems) { @for (item of state.navItems; track item.route) {
    <div
      class="mtc-appbar-nav-item {{ item.cssClass ? item.cssClass : '' }}"
      [routerLink]="item.route"
      routerLinkActive="mtc-appbar-nav-item__active"
      [ngStyle]="{color: item.iconColor}"
    >
      <ux-icon [name]="item.iconName" [weight]="item.iconWeight" [sizeL]="item.iconSize"></ux-icon>
    </div>
    } }
  </div>
</div>
